export const theme = {
    colors:{
        white: '#fff',
        black: '#000000',
        dark: '#2f2f2fa6',
        contentBg: 'rgba(64, 64, 64, 0.52)',
        farGray: 'rgba(255, 255, 255, 0.66)',
        darkGray: 'rgba(131, 131, 131, 0.66)',
        transparent: 'rgba(255, 255, 255, 0)'
    }
}